import React, { Component } from 'react'
import {connect} from 'react-redux'
import MultiLangText from '../multilang/MultiLangText'

import {TimelineMax} from 'gsap';

class KastnerBusinessPopUp extends Component {

  constructor(props){

    super()

    //console.log("KastnerBusinessPopUp",props);

    this.state = {
       content: this.getKastnerBusiness(props.pagesData.data),
       open:false,
       closing:false,
       open_tl:null

    }



    this.openClose = this.openClose.bind(this)
    this.closePopUp = this.closePopUp.bind(this)
    this.openPopUp = this.openPopUp.bind(this)
    this.setupAnimation = this.setupAnimation.bind(this)


  }

  setupAnimation(){

      let open_tl = new TimelineMax({repeat:0})

      open_tl.add(()=>{
        if(this.state.closing==true){
          this.setState({open:false,closing:false})
        }
      })

      open_tl.fromTo(this.refs.popUp,.5,{alpha:0},{alpha:1})

      open_tl.fromTo(this.refs.gradientCover,2,{top:'-100%'},{top:'100%'},'-=0')
      open_tl.from(this.refs.hLine,.2,{width:0},"-=1.2")
      open_tl.from(this.refs.line1,.5,{width:0},'-=.6')
      open_tl.from(this.refs.line2,.5,{width:0},"-=.5")





      open_tl.pause();

      this.setState({open_tl})

      //this.disableHeader = this.disableHeader.bind(this)
      //this.enableHeader = this.enableHeader.bind(this)
  }


  disableHeader(){
    //console.log("Mouse Over");
    //document.querySelector('body').classList.add('force-hide-header');
    document.querySelector('header').classList.add('hide');
    document.querySelector('header').classList.remove('show');
  }
  enableHeader(e){
    //console.log("Mouse Out");
    //document.querySelector('body').classList.remove('force-hide-header');

    if(e){
      if(e.clientY < 100){
        console.log("show header triggred from header");
        document.querySelector('header').classList.add('show');
        document.querySelector('header').classList.remove('hide');
      }
    }

  }

  componentDidMount(){
    this.setupAnimation();
  }

  openClose(){
    let open = !this.state.open
    this.setState({open})
  }

  closePopUp(){
      console.log("Close PopUp");
        this.setState({closing:true})
        this.state.open_tl.reverse();
        this.state.open_tl.timeScale(2.5);
  }

  openPopUp(){
      console.log("Open PopUp");
    this.state.open_tl.play();
    this.state.open_tl.timeScale(1);
    this.setState({open:true})

    this.disableHeader()
    setTimeout(()=>{
      this.enableHeader()
    },1000)


  }

  getKastnerBusiness(pages){
      let page = pages.filter((page,i)=>{
            return(page.slug === 'kastner-business')
      });

      if(page){
        return page[0]
      }else{
        return false
      }
  }

  render() {
    return(
      <div className={"description kastner-business" +(this.state.open? ' open' : ' closed')} onMouseEnter={this.disableHeader} onMouseMove={this.disableHeader}  onMouseLeave={this.enableHeader}>


      <div className="kastner-brand-popup" ref="popUp" >

          <div className="kastner-brand-copy">
            <MultiLangText text={this.state.content.acf} />
            <div className="horizontal-line" ref="hLine" />
            <div className="cover" >
              <div className="gradient" ref="gradientCover" />
            </div>
          </div>

          <div className="close-button" ref="closeButton" onClick={this.closePopUp}>
              <div className="close-line" ref="line1" />
              <div className="close-line" ref="line2"  />
          </div>
      </div>

      <div ref="brandTab" className="kastner-brand-tab" onClick={this.openPopUp}>
      </div>

      </div>
    )
  }
}

const mapStateToProps = (state)=>{

    const pagesData = state.KastnerStore.pagesData

    return {
      pagesData
    }


}

export default connect(mapStateToProps)(KastnerBusinessPopUp)



// WEBPACK FOOTER //
// ./src/modules/work/KastnerBusinessPopUp.js